<div class="questionModel.cssClasses.root" *ngIf="questionModel.visible !== false && questionModel?.choices?.length > 0"
     [formGroup]="form">
  <div class="sv-title-actions">
    <h5 class="sv-string-viewer sv-string-viewer--multiline mb-0" [innerHTML]="questionModel.title"></h5>
  </div>

  <div *ngIf="questionModel.description"
       class="questionModel.cssClasses.description"
       [innerHTML]="questionModel.locDescription?.renderedHtml">
  </div>

  <div *ngIf="questionModel.errors?.length > 0">
    <div *ngFor="let error of questionModel.errors"
         [class]="questionModel.cssClasses.error.item">
      {{ error.getText() }}
    </div>
  </div>

  <div class="sd-selectbase">
    <div *ngFor="let item of questionModel.choices"
         [ngClass]="{'sd-item--checked sd-radio--checked': control?.value === item.value}"
         class="sd-item sd-item--allowhover sd-radio sd-radio--allowhover sd-selectbase__item sv-q-col-1">
      <label class="sd-selectbase__label">
        <input type="radio"
               [formControlName]="this.questionModel.controlName"
               [id]="questionModel.inputId + '_' + item.value"
               class="sd-item__control sd-radio__control sd-visuallyhidden"
               (change)="onChange(item.value)"
        />
        <span class="sd-item__decorator sd-radio__decorator"></span>
        <span class="sd-item__control-label"><span class="sv-string-viewer"
                                                   [innerHTML]="getChoiceItemText(item.text)">
        </span></span>
      </label>
    </div>
  </div>

  <div *ngIf="questionModel.hasComment">
    <div [class]="questionModel.cssClasses.other">
          <textarea [id]="questionModel.commentId"
                    [class]="questionModel.cssClasses.commentArea"
                    [value]="questionModel.comment || ''"
                    (change)="onCommentChange($event)"
                    [placeholder]="questionModel.otherPlaceHolder">
          </textarea>
    </div>
  </div>
</div>
